/** App-defined successful milestones in elapsed milliseconds, not Core Web Vitals.
 * Fixed dimensions keep operational telemetry separate from behavioral inference. */
export const UX_KINDS = [
  'first-screen-request',
  'first-screen-ready',
  'first-image-ready',
  'surface-switch-render',
  'load-more',
];
export const UX_SURFACES = ['wall', 'visual', 'talk', 'circles', 'explore'];
export const UX_MAX_DURATION_MS = 600000;
export const UX_BUCKETS_MS = [
  0, 16, 32, 50, 75, 100, 150, 200, 300, 500, 750, 1000, 1500, 2000, 3000, 5000, 7500, 10000, 15000,
  20000, 30000, 60000, 120000, 180000, 240000, 300000, 600000,
];
export const UX_HOUR_MS = 3600000;
export const UX_RETENTION_HOURS = 168;
/** Reject all unknown fields: no labels, URLs, content, identities or client timestamps. */
export function validateUXTimings(input) {
  if (
    !input ||
    typeof input !== 'object' ||
    Array.isArray(input) ||
    Object.keys(input).length !== 1 ||
    !Array.isArray(input.events) ||
    input.events.length < 1 ||
    input.events.length > 8
  )
    throw new Error('Supply one to eight UX timing events.');
  return input.events.map((event) => {
    if (
      !event ||
      typeof event !== 'object' ||
      Array.isArray(event) ||
      Object.keys(event).length !== 3 ||
      Object.keys(event).some((key) => !['kind', 'surface', 'durationMs'].includes(key)) ||
      !UX_KINDS.includes(event.kind) ||
      !UX_SURFACES.includes(event.surface) ||
      !Number.isInteger(event.durationMs) ||
      event.durationMs < 0 ||
      event.durationMs > UX_MAX_DURATION_MS
    )
      throw new Error('Invalid UX timing event.');
    return { kind: event.kind, surface: event.surface, durationMs: event.durationMs };
  });
}
/** Upper-bound quantiles of fixed noncumulative histogram counts. Small cohorts are
 * suppressed; counts are reports, not unique users and may include retry duplicates. */
export function summarizeUXHistogram(histogram) {
  const count = histogram.reduce((sum, n) => sum + n, 0);
  const percentile = (fraction) => {
    if (count < 5) return null;
    const target = Math.ceil(count * fraction);
    let seen = 0;
    for (let i = 0; i < histogram.length; i++) {
      seen += histogram[i];
      if (seen >= target) return UX_BUCKETS_MS[i];
    }
    return null;
  };
  const first = histogram.findIndex((n) => n > 0);
  let last = -1;
  for (let index = histogram.length - 1; index >= 0; index--)
    if (histogram[index] > 0) {
      last = index;
      break;
    }
  return {
    count,
    observedLowerMs: first < 0 ? null : first === 0 ? 0 : UX_BUCKETS_MS[first - 1] + 1,
    observedUpperMs: last < 0 ? null : UX_BUCKETS_MS[last],
    p50Ms: percentile(0.5),
    p95Ms: percentile(0.95),
  };
}
